import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import './App.css';
import Navbar from './Components/NavbarComponents/Navbar';
import FooterPage from './Components/Pages/FooterPage';
import HeroSection from './Components/Pages/HeroSection';
import HowWorkSection from './Components/Pages/HowWorkSection';
import OurPartnersSection from './Components/Pages/OurPartnersSection';
import OverviewSection from './Components/Pages/OverviewSection';
import RegistrationForm from './Components/Pages/RegistrationForm';
import RunnersSection from './Components/Pages/RunnersSection';
import WaterSection from './Components/Pages/WaterSection';
// import WinnersPrizeSection from "./Components/Pages/WinnersPrizeSection";
import ContactUsSection from "./Components/Pages/ContactUsSection";
import AwardsPage from "./Components/Pages/AwardsPage";
import RippleRunMarathonPage from "./Components/Pages/RippleRunMarathonPage";

function App() {
  return (
    <Router>
      <div className="app">

        
        <Navbar />

        {/* Main Content with Routes */}
        <Routes>

          {/* Home page */}
          <Route
            path="/"
            element={
              <>
                <HeroSection />
                <RippleRunMarathonPage/>
                <RunnersSection />
                <OverviewSection />
                <AwardsPage/>
                <HowWorkSection />
                 {/* <WinnersPrizeSection/> */}
                <WaterSection />
                <OurPartnersSection />
                <RegistrationForm />
                <ContactUsSection/>
              </>
            }
          />

          
         
        </Routes>

      
        <FooterPage />

      </div>
    </Router>
  );
}

export default App;